import { Component, OnInit } from '@angular/core';
import { AbstractWidgetComponent, ConfigurationService, ContextChange, WidgetStyle } from '@sdbn/appclient';
import { COMMON_COUNTRIES, COMMON_LANGUAGES, Country, Language, TranslationService } from '@sdbn/common';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';


export class LanguageValue {
  language?: Language;
  country?: Country;
  constructor(value?: Partial<LanguageValue>) {
    if (value != null) {
      this.language = value.language;
      this.country = value.country;
    }
  }
}

@Component({
  selector: 'app-terminal-language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.scss']
})
export class LanguageSelectionComponent extends AbstractWidgetComponent implements OnInit {

  cardSize = 250;

  public languages = new Array<LanguageValue>();

  public selectedLanguage: string;

  constructor(
    private translationService: TranslationService,
    private cps: ConfigurationService
  ) {
    super();
    let languages = new Array<LanguageValue>();
    let languagesDefinition = this.cps.getClientParamValue("tmc-yard.terminal.allowed-languages");
    for (const languageKey of languagesDefinition.split("|")) {
      const language = COMMON_LANGUAGES.find(l => l.key === languageKey);
      languages.push(new LanguageValue({ language: language, country: COMMON_COUNTRIES.find(c => c.isoCode === language.countryIsoCode) }));
    }
    this.languages = languages;

    const newCardSize = this.cps.getClientParamValue('tmc-yard.terminal.language-selection.card-size');
    if (newCardSize != null) {
      this.cardSize = +newCardSize;
    }
  }

  ngOnInit(): void { }

  onContextChange(contextChange: ContextChange) { }

  onSetElementAndContext() { }

  setLanguage(languageValue: LanguageValue) {
    this.selectedLanguage = languageValue.language.key;
    this.translationService.setLanguage(this.selectedLanguage);
    this.dashboardContext.setContextValue(TerminalContextConstants.language, this.selectedLanguage);
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
